// 格式化工具函数

/**
 * 格式化时间 - 将UTC时间转换为本地时间 (UTC+8)
 */
export function formatTime(timestamp: string | Date | number | null | undefined): string {
  if (!timestamp) return '从未'

  let date: Date

  if (timestamp instanceof Date) {
    date = timestamp
  } else if (typeof timestamp === 'string') {
    let dateStr = timestamp
    if (!timestamp.includes('Z') && !timestamp.includes('+') && !timestamp.includes('-', 10)) {
      dateStr = timestamp + 'Z'
    }
    date = new Date(dateStr)
  } else {
    date = new Date(timestamp)
  }

  if (isNaN(date.getTime())) {
    return String(timestamp)
  }

  return date.toLocaleString('zh-CN', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
}

/**
 * 格式化设备ID
 */
export function formatDeviceId(deviceId: string | null | undefined): string {
  if (!deviceId) return '--'
  return deviceId
}

/**
 * 格式化握手ID（合并ID A和ID B）
 */
export function formatHandshakeId(handshakeIdA?: number, handshakeIdB?: number): string {
  if (handshakeIdA === undefined && handshakeIdB === undefined) {
    return '--'
  }

  if (handshakeIdA !== undefined && handshakeIdB !== undefined) {
    const idA = String(handshakeIdA).padStart(2, '0')
    const idB = String(handshakeIdB).padStart(2, '0')
    return `${idA}${idB}`
  }

  const id = handshakeIdA ?? handshakeIdB
  return String(id).padStart(2, '0')
}

/**
 * 格式化字节大小
 */
export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

/**
 * 获取状态颜色
 */
export function getStateColor(state: string): string {
  const colors: Record<string, string> = {
    'PASSTHROUGH': '#28a745',
    'IDLE': '#ffc107',
    'ERROR': '#dc3545',
    'TCP_CONNECTING': '#17a2b8',
    'WAITING_S_PKT1': '#6c757d',
    'WAITING_S_PKT2': '#6c757d',
    'CLOSING': '#6c757d',
  }
  return colors[state] || '#6c757d'
}

/**
 * 获取升级状态文本
 */
export function getUpgradeStatusText(status: string): string {
  const statusMap: Record<string, string> = {
    'idle': '空闲',
    'pending': '等待中',
    'downloading': '下载中',
    'applying': '升级中',
    'success': '成功',
    'failed': '失败',
  }
  return statusMap[status] || status
}

/**
 * 获取升级状态颜色
 */
export function getUpgradeStatusColor(status: string): string {
  const colorMap: Record<string, string> = {
    'idle': 'default',
    'pending': 'processing',
    'downloading': 'processing',
    'applying': 'warning',
    'success': 'success',
    'failed': 'error',
  }
  return colorMap[status] || 'default'
}
